<template>
  <div>
    <div class="subtitle-3">{{ $t('LoggedArea.Settings.Security.subtitle') }}</div>
    <div class="error-text" v-if="error">{{ error }}</div>

    <template v-if="!confirmeDelete">
      <a
        class="caption change-password pt-0"
        @click="updatePassword"
      >{{ $t('LoggedArea.Settings.Security.changePassword') }}</a>
      <br />
      <a
        class="caption change-password pt-0"
        @click="confirmeDelete = true"
      >{{ $t('LoggedArea.Settings.Security.deleteAccount') }}</a>
    </template>

    <v-chip
      class="mt-2 mb-1 mx-1"
      close
      color="purple darken-4"
      text-color="white"
      v-else
      @click="deleteAccount"
      @click:close="confirmeDelete = false"
      style="outline: none;"
    >
      <span class="m-2">{{ $t('LoggedArea.Settings.Security.removeMyAccount') }}</span>
    </v-chip>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
export default {
  data() {
    return {
      error: "",
      confirmeDelete: false,
    };
  },
  methods: {
    async updatePassword() {
      const emailUser = firebase.auth().currentUser.email;
      await firebase
        .auth()
        .sendPasswordResetEmail(emailUser)
        .then(
          (this.error = this.$t(
            "LoggedArea.Settings.Security.sendEmailResetPassword"
          ))
        )
        .catch((error) => (this.error = error));
    },
    async deleteAccount() {
      const database = firebase.database();
      const uid = firebase.auth().currentUser.uid;
      //remove the user from users table
      const usersRef = database.ref("/users");
      await usersRef.child(uid).remove();
      //remove analytcs from analytics table
      const analyticsRef = database.ref("/analytics");
      await analyticsRef.child(uid).remove();
      //take user out after the deletion
      firebase
        .auth()
        .currentUser.delete()
        .then(() => {
          this.$router.replace({ name: "login" });
        })
        .catch((error) => (this.error = error));
    },
  },
};
</script>
<style>
.change-password {
  text-align: right;
  font-size: 13px;
  color: #7a7a7a;
  margin: 0;
}
</style>